module.exports = __webpack_public_path__ + "assets/images/speech-bubbles_esmerald.svg?9e56ed78ddb020b63e28f3535c6820ce";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/speech-bubbles_esmerald.svg
// module id = 616
// module chunks = 0